// extracted by css-extract-rspack-plugin
export default {"spaceFluid":"100%","spaceMedium":"20px","evaluationFormViewContainer":"evaluation__evaluationFormViewContainer___Os7EL"};